"use client";

import React from "react";
import SignInButton from "./SignInButton";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import { MINIO_URL } from "@/lib/constant";

const AppBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="border-b-4 border-gray-200 bg-customDarkBlue border-b-customOrange">
      <div className="flex flex-wrap items-center justify-between p-4 mx-auto w-screen-xl">
        <Link href="/">
          <Image
            src={`${MINIO_URL}/images/klc-logo.png`}
            width={150}
            height={0}
            alt="KLC logo"
          />
        </Link>

        <button
          onClick={toggleMenu}
          data-collapse-toggle="navbar-default"
          type="button"
          className="inline-flex items-center justify-center w-10 h-10 p-2 text-sm text-white rounded-lg md:hidden focus:outline-none focus:ring-2 "
          aria-controls="navbar-default"
          aria-expanded="false"
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>
        <div
          className={`md:block ${isOpen ? "block" : "hidden"} w-full md:w-auto`}
        >
          <ul className="flex flex-col p-4 mt-4 font-light rounded-lg md:p-0 md:flex-row md:space-x-4 rtl:space-x-reverse md:mt-0 md:border-0">
            <li>
              <Link
                href="/"
                className="block px-1 py-2 text-white transition-colors duration-200 ease-in-out rounded md:hover:bg-transparent md:border-0 hover:scale-105"
              >
                Pelatihan
              </Link>
            </li>
            <li>
              <Link
                href="/"
                className="block px-1 py-2 text-white transition-colors duration-200 ease-in-out rounded md:hover:bg-transparent md:border-0 hover:scale-105"
              >
                Pusat Pengetahuan
              </Link>
            </li>
            <li>
              <Link
                href="/"
                className="block px-1 py-2 text-white transition-colors duration-200 ease-in-out rounded md:hover:bg-transparent md:border-0 hover:scale-105"
              >
                Pusat Bantuan
              </Link>
            </li>

            <li className="border-r-2 border-white rounded-xl"></li>

            <li>
              <SignInButton />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default AppBar;
